/**
 * @Copyright 2014-2018 DataVoke, Inc. All rights reserved.
 */

'use strict';

export class ValidationRule {
    constructor (id) {
        this.id = id;
    }

    /**
     * Base class function to validate the specified value.
     * @param {*} value
     * @returns {boolean}
     */
    validate (value) {
        return true;
    }
}

export class RegExValidationRule extends ValidationRule {
    constructor (id, regexString) {
        super(id);

        this.regexString = regexString;

        if (regexString != null) {
            try {
                this.regex = new RegExp(regexString);
            }
            catch (e) {
                this.regex = undefined;
                console.warn(`Unable to create regular expression rule for ${id}`);
            }
        }
    }

    /**
     * Validate the specified string using the regular expression of this rule object.
     * @param {string} value
     * @returns {boolean}
     * @override
     */
    validate (value) {
        if (this.regex) {
            return this.regex.test(value);
        }

        // if no regex, then default to true.
        return true;
    }
}
